import { useSelector } from 'react-redux';

import { START_FREE_LINK, SUBSCRIPTIONS_LINK } from '../../common/urlLinks';

/**
 * Resolves a landing call to action for the current visitor. The marketing
 * pages also render inside the signed-in app, where "start for free" makes no
 * sense: someone who already has an account is sent to the plans instead.
 * Returns `{ to, labelId }`; `labelId` is null when the page's own label
 * should be used.
 */
export default function useStartCta(to) {
    const loggedIn = useSelector((state) => Boolean(state.profile && state.profile.loggedIn));

    if (loggedIn && to === START_FREE_LINK) {
        return { to: SUBSCRIPTIONS_LINK, labelId: 'redesign.cta.plans' };
    }
    return { to, labelId: null };
}
